export const useUrlQueryComponent = () => {
    const urlUrlQueryComponent = new URLSearchParams(window.location.search)
    const queryParameterLibrary = new Map() 

    queryParameterLibrary.set('requestQuote', {key: 'option', value: 'offer'});

    const isContentDisplayed = (queryParameterGroup) => {
        let result = true /* Without parameter go with offer */
        const keyValuePair = queryParameterLibrary.get(queryParameterGroup)
        if (urlUrlQueryComponent.has(keyValuePair.key)) {
            result = urlUrlQueryComponent.get(keyValuePair.key) === keyValuePair.value
        }
        return result
    }

    return {
        isContentDisplayed
    }
}
